import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { AuthBoxContainer, AuthBox } from '@/components/AuthBox';
import { TitleText } from '@/components/TitleText';

const CnSignInPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loggedOut = (location.state as { loggedOut?: boolean } | undefined)?.loggedOut === true;
  const hasRetried = useRef(false);

  useEffect(() => {
    if (loggedOut || hasRetried.current) {
      return;
    }

    // After a 401 redirect clears the stale token, navigate back to /
    // so useCnAuth can attempt a fresh token exchange (with its own retries).
    hasRetried.current = true;
    localStorage.removeItem('authToken');
    navigate('/', { replace: true });
  }, [loggedOut, navigate]);

  if (loggedOut) {
    return (
      <AuthBoxContainer>
        <AuthBox>
          <TitleText>Session Ended</TitleText>
          <Typography>To sign out completely, close your browser.</Typography>
        </AuthBox>
      </AuthBoxContainer>
    );
  }

  return (
    <AuthBoxContainer>
      <AuthBox>
        <TitleText>Authentication Failed</TitleText>
        <Typography>Unable to authenticate. Please contact your administrator.</Typography>
      </AuthBox>
    </AuthBoxContainer>
  );
};

export default CnSignInPage;
